import React from "react"
import 'suneditor/dist/css/suneditor.min.css'
import "../styles/globals.css"
import AppProviders from "../context"
import { ModalProvider } from "../context/ModalContext"
import { ToastContainer } from '../components/Toast/ToastContainer';
import Analytics from "../components/global/Analytics/Analytics"
import NewsletterPopup from "../components/global/NewsletterPopup/NewsletterPopup";
import { useRouter } from "next/router";
import Head from "next/head";
import reportAccessibility from "../utils/reportAccessibility";

const VinousApp = ({ Component, pageProps }) => {
  const router = useRouter();
  const canonicalUrl = (`https://vinous.com` + (router.asPath === "/" ? "": router.asPath));
  const isNoIndex = process.env.NEXT_PUBLIC_ROBOTS_NOINDEX === "true"

  return (
    <AppProviders initialUser={pageProps.user} initialSubscription={pageProps.subscription}>
      <Head>
        {canonicalUrl.includes("?") ? <link rel="canonical" href={canonicalUrl} /> : null}
        {isNoIndex ? <meta name="robots" content="noindex, nofollow" /> : null}
      </Head>
      <ModalProvider>
        <NewsletterPopup />
        <main>
          <Component {...pageProps} />
          <ToastContainer />
        </main>
      </ModalProvider>
      <Analytics />
    </AppProviders>
  )
}

reportAccessibility(React);

export default VinousApp;
